<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet
        :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`"
        class="pa-3"
      >
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div class="mt-1" v-else>
      <v-row>
        <v-col xs="12" sm="12" md="9" lg="9" xl="9" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">สรุปยอดก่อนปิดร้าน</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>
      </v-row>
      <div class="mt-1">
        <v-row>
          <v-col>
            <v-card elevation="2" class="mx-auto input-radius mb-6" outlined>
              <v-list-item three-line>
                <v-list-item-avatar size="61">
                  <v-img
                    lazy-src="@/assets/arin_assets/money.png"
                    src="@/assets/arin_assets/money.png"
                  ></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    <div class="font-32 text-right bold text-brown">
                      {{ formatPrice(total.total_cash) }}
                    </div>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <div class="font-16 text-right bold">เงินสด</div>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
            <v-card elevation="2" class="mx-auto input-radius" outlined>
              <v-list-item three-line>
                <v-list-item-avatar size="61">
                  <v-img
                    lazy-src="@/assets/arin_assets/money.png"
                    src="@/assets/arin_assets/money.png"
                  ></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    <div class="font-32 text-right bold text-brown">
                      {{ formatPrice(total.total_cash_vat) }}
                    </div>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <div class="font-16 text-right bold">เงินสด (VAT)</div>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>

          <v-col>
            <v-card elevation="2" class="mx-auto input-radius mb-6" outlined>
              <v-list-item three-line>
                <v-list-item-avatar size="61">
                  <v-img
                    lazy-src="@/assets/arin_assets/phone_bank.png"
                    src="@/assets/arin_assets/phone_bank.png"
                  ></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    <div class="font-32 text-right bold text-brown">
                      {{ formatPrice(total.total_payment) }}
                    </div>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <div class="font-16 text-right bold">เงินโอน</div>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
            <v-card elevation="2" class="mx-auto input-radius" outlined>
              <v-list-item three-line>
                <v-list-item-avatar size="61">
                  <v-img
                    lazy-src="@/assets/arin_assets/phone_bank.png"
                    src="@/assets/arin_assets/phone_bank.png"
                  ></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    <div class="font-32 text-right bold text-brown">
                      {{ formatPrice(total.total_payment_vat) }}
                    </div>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <div class="font-16 text-right bold">เงินโอน (VAT)</div>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>

          <v-col>
            <v-card elevation="2" class="mx-auto input-radius mb-6" outlined>
              <v-list-item three-line>
                <v-list-item-avatar size="61">
                  <v-img
                    lazy-src="@/assets/arin_assets/phone_bank.png"
                    src="@/assets/arin_assets/phone_bank.png"
                  ></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    <div class="font-32 text-right bold text-brown">
                      {{ formatPrice(total.total_qr) }}
                    </div>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <div class="font-16 text-right bold">Qr payment</div>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
            <v-card elevation="2" class="mx-auto input-radius" outlined>
              <v-list-item three-line>
                <v-list-item-avatar size="61">
                  <v-img
                    lazy-src="@/assets/arin_assets/phone_bank.png"
                    src="@/assets/arin_assets/phone_bank.png"
                  ></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    <div class="font-32 text-right bold text-brown">
                      {{ formatPrice(total.total_qr_vat) }}
                    </div>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <div class="font-16 text-right bold">Qr payment (VAT)</div>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>

        
          <!-- <v-col>
                <v-card elevation="2" class="mx-auto input-radius" outlined>
                    <v-list-item three-line>
                        <v-list-item-avatar size="61">
                            <v-img lazy-src="@/assets/arin_assets/phone_bank.png"
                                src="@/assets/arin_assets/qr-code.png"></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>
                                <div class="font-32 text-right bold text-brown">
                                    {{ formatPrice(total.total_qr) }}
                                </div>
                            </v-list-item-title>
                            <v-list-item-subtitle>
                                <div class="font-16 text-right bold">
                                    เงิน QR CODE
                                </div>
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-card>
            </v-col> -->
          <v-col>
            <v-card elevation="2" class="mx-auto input-radius mb-6" outlined>
              <v-list-item three-line>
                <v-list-item-avatar size="61">
                  <v-img
                    lazy-src="@/assets/arin_assets/card.png"
                    src="@/assets/arin_assets/card.png"
                  ></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    <div class="font-32 text-right bold text-brown">
                      {{ formatPrice(total.total_credit) }}
                    </div>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <div class="font-16 text-right bold">บัตรเครดิต</div>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
            <v-card elevation="2" class="mx-auto input-radius" outlined>
              <v-list-item three-line>
                <v-list-item-avatar size="61">
                  <v-img
                    lazy-src="@/assets/arin_assets/card.png"
                    src="@/assets/arin_assets/card.png"
                  ></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    <div class="font-32 text-right bold text-brown">
                      {{ formatPrice(total.total_credit_vat) }}
                    </div>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <div class="font-16 text-right bold">บัตรเครดิต (VAT)</div>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col>
            <v-card elevation="2" class="mx-auto input-radius mb-6" outlined>
              <v-list-item three-line>
                <v-list-item-avatar size="61">
                  <v-img
                    lazy-src="@/assets/arin_assets/money_big.png"
                    src="@/assets/arin_assets/money_big.png"
                  ></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="d-flex justify-end">
                    <div>
                      <v-btn
                        elevation="2"
                        class=" mr-2 font-16 btn-detail"
                        outlined
                        color="#8EBBDC"
                        title="ดูรายละเอียด"
                        style="border-radius: 10px"
                        @click="getPaymentOther(false)"
                      >
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                    </div>
                    <div class="font-32 text-right bold text-brown">
                      {{ formatPrice(total.total_etc) }}
                    </div>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <div class="font-16 text-right bold">อื่นๆ</div>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
            <v-card elevation="2" class="mx-auto input-radius" outlined>
              <v-list-item three-line>
                <v-list-item-avatar size="61">
                  <v-img
                    lazy-src="@/assets/arin_assets/money_big.png"
                    src="@/assets/arin_assets/money_big.png"
                  ></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="d-flex justify-end">
                    <div>
                      <v-btn
                        elevation="2"
                        class=" mr-2 font-16 btn-detail"
                        outlined
                        color="#8EBBDC"
                        title="ดูรายละเอียด"
                        style="border-radius: 10px"
                        @click="getPaymentOther(true)"
                      >
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                    </div>
                    <div class="font-32 text-right bold text-brown">
                      {{ formatPrice(total.total_etc_vat) }}
                    </div>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <div class="font-16 text-right bold">อื่นๆ (VAT)</div>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="12" md="6" lg="6" xl="6">
            <v-card elevation="2" class="mx-auto input-radius" outlined>
              <v-list-item three-line>
                <v-list-item-avatar size="61">
                  <v-img
                    lazy-src="@/assets/arin_assets/phone_bank.png"
                    src="@/assets/arin_assets/bill (2).png"
                  ></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    <div class="font-32 text-right bold text-brown">
                      {{ formatPrice(total.total_vat) }}
                    </div>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <div class="font-16 text-right bold">
                      มูลค่ารวมใบเสร็จคิด VAT
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col sm="12" md="6" lg="6" xl="6">
            <v-card elevation="2" class="mx-auto input-radius" outlined>
              <v-list-item three-line>
                <v-list-item-avatar size="61">
                  <v-img
                    lazy-src="@/assets/arin_assets/phone_bank.png"
                    src="@/assets/arin_assets/bill (2).png"
                  ></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    <div class="font-32 text-right bold text-brown">
                      {{ formatPrice(total.total_no_vat) }}
                    </div>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <div class="font-16 text-right bold">
                      มูลค่ารวมใบเสร็จไม่คิด VAT
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>

        <v-form ref="summary" @submit.prevent="open_model_close">
          <v-row>
            <v-col cols="12" lg="6" xl="6">
              <v-card elevation="3" class="pa-4" style="border-radius: 15px">
                <section class="pa-3">
                  <v-row class="">
                    <v-col cols="12 font-20 bold">การสรุปยอดเงินที่มี</v-col>
                  </v-row>

                  <v-row class="border-close input-radius mb-3">
                    <v-col cols="12 pb-0">
                      <label for="">ยอดเงินสด 
                        <span class="required--text">*</span> 
                        <span style="color: #bebebe !important;"> {{ parseFloat(total.total_cash) + parseFloat(total.total_cash_vat) }} บาท</span> 
                      </label>
                    </v-col>
                    <v-col cols="6">
                      <v-form-group>
                        <v-text-field
                          color="#D6BFAF"
                          class="input-radius"
                          prepend-inner-icon="mdi-alpha-s-circle"
                          type="number"
                          hide-details="auto"
                          :rules="[(v) => !!v || 'กรุณากรอกข้อมูล']"
                          v-model="total_all.cash"
                          @input="calculate()"
                          placeholder="กรุณากรอกยอดเงินสด"
                          single-line
                          outlined
                          dense
                          required
                        ></v-text-field>
                      </v-form-group>
                    </v-col>
                    <v-col cols="6">
                      <div
                        v-if="
                          total_all.cash == null ||
                          total_all.cash == '' ||
                          parseFloat(total_all.cash - (parseFloat(total.total_cash) + parseFloat(total.total_cash_vat))) == 0
                        "
                      >
                        เงินสดส่วนต่าง 0 บาท
                      </div>
                      <div v-else>
                        <div
                          style="color: #88b358"
                          v-if="
                            parseFloat(
                              total_all.cash
                                ? total_all.cash
                                : 0 - (parseFloat(total.total_cash) + parseFloat(total.total_cash_vat))
                            ) > parseFloat(parseFloat(total.total_cash) + parseFloat(total.total_cash_vat))
                          "
                        >
                          <span style="color: black">เงินสดส่วนต่าง</span>
                          {{
                            total_all.cash == null || total_all.cash == ""
                              ? 0
                              : "+" +
                                formatPrice(
                                  parseFloat(total_all.cash - (total.total_cash  + total.total_cash_vat ))
                                )
                          }}
                          <span style="color: black">บาท</span>
                        </div>
                        <div style="color: red" v-else>
                          <span style="color: black">เงินสดส่วนต่าง</span>
                          {{
                            total_all.cash == null || total_all.cash == ""
                              ? 0
                              : formatPrice(
                                  parseFloat(total_all.cash - (parseFloat(total.total_cash)  + parseFloat(total.total_cash_vat)))
                                )
                          }}
                          <span style="color: black">บาท</span>
                        </div>
                      </div>
                    </v-col>
                  </v-row>

                  <v-row class="border-close input-radius mb-3">
                    <v-col cols="12 pb-0">
                      <label for=""
                        >ยอดเงินโอน <span class="required--text">*</span> 
                        <span style="color: #bebebe !important;"> {{ parseFloat(total.total_payment) + parseFloat(total.total_payment_vat) }} บาท</span> 
                        </label
                      >
                    </v-col>
                    <v-col cols="6">
                      <v-form-group>
                        <v-text-field
                          color="#D6BFAF"
                          class="input-radius"
                          prepend-inner-icon="mdi-alpha-s-circle"
                          type="number"
                          hide-details="auto"
                          :rules="[(v) => !!v || 'กรุณากรอกข้อมูล']"
                          v-model="total_all.payment"
                          @input="calculate()"
                          placeholder="กรุณากรอกยอดเงินโอน"
                          single-line
                          outlined
                          dense
                          required
                        ></v-text-field>
                      </v-form-group>
                    </v-col>
                    <v-col cols="6">
                      <div
                        v-if="
                          total_all.payment == null ||
                          total_all.payment == '' ||
                          parseFloat(total_all.payment - (parseFloat(total.total_payment) + parseFloat(total.total_payment_vat))) ==
                            0
                        "
                      >
                        เงินสดส่วนต่าง 0 บาท
                      </div>
                      <div v-else>
                        <div
                          style="color: #88b358"
                          v-if="
                            parseFloat(
                              total_all.payment
                                ? total_all.payment
                                : 0 - (parseFloat(total.total_payment) + parseFloat(total.total_payment_vat))
                            ) > parseFloat(parseFloat(total.total_payment) + parseFloat(total.total_payment_vat))
                          "
                        >
                          <span style="color: black">เงินสดส่วนต่าง</span>
                          {{
                            total_all.payment == null || total_all.payment == ""
                              ? 0
                              : "+" +
                                formatPrice(
                                  parseFloat(
                                    total_all.payment - (parseFloat(total.total_payment) + parseFloat(total.total_payment_vat))
                                  )
                                )
                          }}
                          <span style="color: black">บาท</span>
                        </div>
                        <div style="color: red" v-else>
                          <span style="color: black">เงินสดส่วนต่าง</span>
                          {{
                            total_all.payment == null || total_all.payment == ""
                              ? 0
                              : formatPrice(
                                  parseFloat(
                                    total_all.payment - (parseFloat(total.total_payment) + parseFloat(total.total_payment_vat))
                                  )
                                )
                          }}
                          <span style="color: black">บาท</span>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="border-close input-radius mb-3">
                    <v-col cols="12 pb-0">
                      <label for=""
                        >ยอดเงิน Qr code
                        <span class="required--text">*</span>
                        <span style="color: #bebebe !important;"> {{ parseFloat(total.total_qr) + parseFloat(total.total_qr_vat) }} บาท</span> 
                        </label
                      >
                    </v-col>
                    <v-col cols="6">
                      <v-form-group>
                        <v-text-field
                          color="#D6BFAF"
                          class="input-radius"
                          prepend-inner-icon="mdi-alpha-s-circle"
                          type="number"
                          hide-details="auto"
                          :rules="[(v) => !!v || 'กรุณากรอกข้อมูล']"
                          v-model="total_all.qr"
                          @input="calculate()"
                          placeholder="กรุณากรอกยอดเงินQR CODE"
                          single-line
                          outlined
                          dense
                          required
                        ></v-text-field>
                      </v-form-group>
                    </v-col>
                    <v-col cols="6">
                      <div
                        v-if="
                          total_all.qr == null ||
                          total_all.qr == '' ||
                          parseFloat(total_all.qr - (parseFloat(total.total_qr) + parseFloat(total.total_qr_vat))) == 0
                        "
                      >
                        เงินสดส่วนต่าง 0 บาท
                      </div>
                      <div v-else>
                        <div
                          style="color: #88b358"
                          v-if="
                            parseFloat(
                              total_all.qr ? total_all.qr : 0 - (parseFloat(total.total_qr) + parseFloat(total.total_qr_vat))
                            ) > parseFloat(parseFloat(total.total_qr) + parseFloat(total.total_qr_vat))
                          "
                        >
                          <span style="color: black">เงินสดส่วนต่าง</span>
                          {{
                            total_all.qr == null || total_all.qr == ""
                              ? 0
                              : "+" +
                                formatPrice(
                                  parseFloat(total_all.qr - (parseFloat(total.total_qr) + parseFloat(total.total_qr_vat)))
                                )
                          }}
                          <span style="color: black">บาท</span>
                        </div>
                        <div style="color: red" v-else>
                          <span style="color: black">เงินสดส่วนต่าง</span>
                          {{
                            total_all.qr == null || total_all.qr == ""
                              ? 0
                              : formatPrice(
                                  parseFloat(total_all.qr - (parseFloat(total.total_qr) + parseFloat(total.total_qr_vat)))
                                )
                          }}
                          <span style="color: black">บาท</span>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="border-close input-radius mb-3">
                    <v-col cols="12 pb-0">
                      <label for=""
                        >ยอดเงินบัตรเครดิต
                        <span class="required--text">*</span>
                        <span style="color: #bebebe !important;"> {{ parseFloat(total.total_credit) + parseFloat(total.total_credit_vat) }} บาท</span> 
                        </label
                      >
                    </v-col>
                    <v-col cols="6">
                      <v-form-group>
                        <v-text-field
                          color="#D6BFAF"
                          class="input-radius"
                          prepend-inner-icon="mdi-alpha-s-circle"
                          type="number"
                          hide-details="auto"
                          :rules="[(v) => !!v || 'กรุณากรอกข้อมูล']"
                          v-model="total_all.credit"
                          @input="calculate()"
                          placeholder="กรุณากรอกยอดเงินบัตรเครดิต"
                          single-line
                          outlined
                          dense
                          required
                        ></v-text-field>
                      </v-form-group>
                    </v-col>
                    <v-col cols="6">
                      <div
                        v-if="
                          total_all.credit == null ||
                          total_all.credit == '' ||
                          parseFloat(total_all.credit - (parseFloat(total.total_credit) + parseFloat(total.total_credit_vat))) == 0
                        "
                      >
                        เงินสดส่วนต่าง 0 บาท
                      </div>
                      <div v-else>
                        <div
                          style="color: #88b358"
                          v-if="
                            parseFloat(
                              total_all.credit
                                ? total_all.credit
                                : 0 - (parseFloat(total.total_credit) + parseFloat(total.total_credit_vat))
                            ) > parseFloat((parseFloat(total.total_credit) + parseFloat(total.total_credit_vat)))
                          "
                        >
                          <span style="color: black">เงินสดส่วนต่าง</span>
                          {{
                            total_all.credit == null || total_all.credit == ""
                              ? 0
                              : "+" +
                                formatPrice(
                                  parseFloat(
                                    total_all.credit - (parseFloat(total.total_credit) + parseFloat(total.total_credit_vat))
                                  )
                                )
                          }}
                          <span style="color: black">บาท</span>
                        </div>
                        <div style="color: red" v-else>
                          <span style="color: black">เงินสดส่วนต่าง</span>
                          {{
                            total_all.credit == null || total_all.credit == ""
                              ? 0
                              : formatPrice(
                                  parseFloat(
                                    total_all.credit - (parseFloat(total.total_credit) + parseFloat(total.total_credit_vat))
                                  )
                                )
                          }}
                          <span style="color: black">บาท</span>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="border-close input-radius mb-3">
                    <v-col cols="12 pb-0">
                      <label for=""
                        >ยอดเงินอื่น ๆ
                        <span class="required--text">*</span>
                        <span style="color: #bebebe !important;"> {{ parseFloat(total.total_etc) + parseFloat(total.total_etc_vat) }} บาท</span> 
                        </label
                      >
                    </v-col>
                    <v-col cols="6">
                      <v-form-group>
                        <v-text-field
                          color="#D6BFAF"
                          class="input-radius"
                          prepend-inner-icon="mdi-alpha-s-circle"
                          type="number"
                          hide-details="auto"
                          :rules="[(v) => !!v || 'กรุณากรอกข้อมูล']"
                          v-model="total_all.etc"
                          @input="calculate()"
                          placeholder="กรุณากรอกยอดเงินอื่น ๆ"
                          single-line
                          outlined
                          dense
                          required
                        ></v-text-field>
                      </v-form-group>
                    </v-col>
                    <v-col cols="6">
                      <div
                        v-if="
                          total_all.etc == null ||
                          total_all.etc == '' ||
                          parseFloat(total_all.etc - (parseFloat(total.total_etc) + parseFloat(total.total_etc_vat))) == 0
                        "
                      >
                        เงินสดส่วนต่าง 0 บาท
                      </div>
                      <div v-else>
                        <div
                          style="color: #88b358"
                          v-if="
                            parseFloat(
                              total_all.etc
                                ? total_all.etc
                                : 0 - (parseFloat(total.total_etc) + parseFloat(total.total_etc_vat))
                            ) > parseFloat((parseFloat(total.total_etc) + parseFloat(total.total_etc_vat)))
                          "
                        >
                          <span style="color: black">เงินสดส่วนต่าง</span>
                          {{
                            total_all.etc == null || total_all.etc == ""
                              ? 0
                              : "+" +
                                formatPrice(
                                  parseFloat(total_all.etc - (parseFloat(total.total_etc) + parseFloat(total.total_etc_vat)))
                                )
                          }}
                          <span style="color: black">บาท</span>
                        </div>
                        <div style="color: red" v-else>
                          <span style="color: black">เงินสดส่วนต่าง</span>
                          {{
                            total_all.etc == null || total_all.etc == ""
                              ? 0
                              : formatPrice(
                                  parseFloat(total_all.etc - (parseFloat(total.total_etc) + parseFloat(total.total_etc_vat)))
                                )
                          }}
                          <span style="color: black">บาท</span>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </section>
              </v-card>
            </v-col>

            <v-col cols="12" lg="6" xl="6">
              <v-card elevation="3" class="pa-4" style="border-radius: 15px">
                <section class="pa-3">
                  <v-row class="">
                    <v-col cols="12 font-20 bold">สรุปเงินส่วนต่าง</v-col>
                  </v-row>
                  <div class="title_page_end">
                    <v-row
                      class="border-close input-radius mb-2 mr-1 ml-1 py-2"
                      style="width: 50%"
                    >
                      <v-col cols="12 text-center">
                        <label for="font-22"
                          >ยอดขายรวม
                          <span class="text-green">
                            {{ formatPrice(total.total_amount) }} บาท
                          </span>
                        </label>
                      </v-col>
                    </v-row>

                    <v-row
                      class="border-close input-radius mb-2 mr-1 ml-1 py-2"
                      style="width: 50%"
                    >
                      <v-col cols="12 text-center">
                        <label for="font-22">
                          เงินส่วนต่าง
                          <span class="text-red"
                            >{{ formatPrice(total.total_all) }}
                          </span>
                          บาท</label
                        >
                      </v-col>
                    </v-row>
                  </div>
                  <v-row class="mt-1">
                    <v-col cols="12 pb-0">
                      <label for="">เหตุผล</label>
                    </v-col>
                    <v-col cols="12">
                      <v-form-group>
                        <v-textarea
                          solo
                          name="input-7-4"
                          label="กรุณากรอกเหตุผล"
                          v-model="note"
                        ></v-textarea>
                      </v-form-group>
                    </v-col>
                    <v-col>
                      <div class="text-right">
                        <v-btn
                          type="submit"
                          height="45"
                          width="150"
                          class="white--text grad-success-arin-bg mobile_btn"
                          style="font-size: 18px; border-radius: 10px"
                          >ปิดร้าน</v-btn
                        >
                      </div>
                    </v-col>
                  </v-row>
                </section>
              </v-card>
            </v-col>
          </v-row>
        </v-form>
      </div>

      <!-- Modal ยืนยันการปิดร้าน -->
      <v-dialog v-model="show_close" persistent max-width="400px">
        <v-card class="input-radius pa-5">
          <v-card-title>
            <v-row>
              <v-col cols="6" class="bold py-0"> ยืนยันการปิดร้าน </v-col>
              <v-col cols="6" class="text-right py-0">
                <v-btn icon class="ma-1" @click="close_model_all()">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text class="">
            <v-row>
              <v-col cols="12 title_page_center">
                <div class="text-center">
                  <v-img
                    width="90"
                    class="w-100"
                    src="@/assets/arin_assets/close.png"
                    lazy-src="@/assets/arin_assets/close.png"
                  ></v-img>
                </div>
              </v-col>

              <v-col cols="12 text-center">
                <div class="font-18">คุณต้องการปิดร้านใช่หรือไม่</div>
              </v-col>

              <v-col>
                <div class="text-right">
                  <v-btn
                    @click="saveData()"
                    type="submit"
                    height="45"
                    width="150"
                    class="white--text grad-success-arin-bg mobile_btn"
                    style="font-size: 18px; border-radius: 10px"
                    >ยืนยัน</v-btn
                  >
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="open_payment_other" persistent max-width="1200">
        <v-card class="input-radius">
          <div class="d-flex justify-space-between">
            <v-card-title>
              <b>รายการใบเสร็จอื่นๆ</b>
            </v-card-title>
            <v-btn icon class="ma-4" @click="open_payment_other = false">
              <v-icon color="grey">mdi-close</v-icon>
            </v-btn>
          </div>
          <v-card-title style="display: flex; justify-content: flex-end">
            <div>
              <v-text-field
                color="#D6BFAF"
                class="input-radius"
                append-icon="mdi-magnify"
                hide-details="auto"
                @input="pagination(0, 10, search), (page = 1)"
                v-model="search"
                placeholder="ค้นหา..."
                single-line
                outlined
                dense
              ></v-text-field>
            </div>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col
                xs="12"
                sm="12"
                md="12"
                lg="12"
                xl="12"
                cols="12"
                class="my-2"
              >
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">เลขที่ใบเสร็จ</th>
                        <th class="text-left">ราคารวม</th>
                        <th class="text-left">หมายเหตุ</th>
                        <th class="text-left">วันที่</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in payment_other_list"
                        :key="item.id"
                        @click="addItem(item.barcode)"
                      >
                        <td>{{ item.invoice_code }}</td>
                        <td>{{ item.total }}</td>
                        <td>{{ item.pay_note   }}</td>
                        <td>{{ item.created_at }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12">
                <div
                  class="text-center"
                  @click="
                    pagination(
                      parseFloat(page > 1 ? 10 * (page - 1) : 0),
                      parseFloat(10) * parseFloat(page),
                      search
                    )
                  "
                >
                  <v-pagination
                    color="#d0b19b"
                    v-model="page"
                    :total-visible="7"
                    :length="page_all"
                  ></v-pagination>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { HTTP_ARIN } from "@/axios_arin";
import { formatPrice } from "@/js/handler";
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Pos_invoices_close_summary",
  data() {
    return {
      loading_page: false,
      dialog_cancel_order: false,
      show_close: false,

      search: "",
      cash_back: "",
      transfer: "",
      credit: "",
      other_cash: "",
      detail: "",
      footer_Props: {
        "items-per-page-text": "รายการต่อหน้า",
      },
      headers: [
        {
          text: "เลขที่ใบเสร็จ",
          value: "receipt_number",
          fixed: true,
          width: "120px",
        },
        {
          text: "เลขที่ใบแจ้งหนี้/ใบกำกับภาษี",
          value: "receipt_tax",
          fixed: true,
          width: "200px",
        },
        {
          text: "วันที่เอกสาร",
          value: "receipt_date",
          fixed: true,
          width: "120px",
        },
        {
          text: "ชื่อลูกค้า",
          value: "receipt_name",
          fixed: true,
          width: "210px",
        },
        {
          text: "ยอดเงินสุทธิ",
          value: "receipt_price",
          fixed: true,
          width: "130px",
        },
        {
          text: "จัดการ",
          value: "",
          fixed: true,
          width: "120px",
        },
      ],

      data_list: [
        {
          receipt_number: "inv-15774124",
          receipt_tax: "tax-inv20221209009",
          receipt_date: "09/12/2022",
          receipt_name: "บริษัท ก.ข.ค. จำกัด (สำนักงานใหญ่)",
          receipt_price: "107.00",
        },
        {
          receipt_number: "inv-15774123",
          receipt_tax: "tax-inv20221209008",
          receipt_date: "08/12/2022",
          receipt_name: "อลิยา กฤตรินทร์",
          receipt_price: "2,479.00",
        },
        {
          receipt_number: "inv-15774122",
          receipt_tax: "tax-inv20221209007",
          receipt_date: "07/12/2022",
          receipt_name: "ชิณณวรรธน์ ปุณณัตถ์",
          receipt_price: "163.00",
        },
      ],
      sub_menu: [
        {
          text: "ระบบ POS",
          disabled: false,
        },
        {
          text: "การขาย",
          disabled: false,
        },
        {
          text: "สรุปยอดก่อนปิดร้าน",
          disabled: false,
        },
      ],
      total: {
        total_cash: 0,
        total_payment: 0,
        total_qr: 0,
        total_credit: 0,
        total_etc: 0,
        total_amount: 0,
        total_all: 0,
        total_cash_vat: 0,
        total_payment_vat: 0,
        total_credit_vat: 0,
        total_qr_vat: 0,
        total_etc_vat: 0,
      },
      total_all: {
        cash: null,
        payment: null,
        qr: null,
        credit: null,
        etc: null,
        cash_vat: null,
        payment_vat: null,
        credit_vat: null,
        qr_vat: null,
        etc_vat: null,
      },
      customer_id: null,
      note: null,
      sum_total_vat: 0,
      sum_total_no_vat: 0,
      open_payment_other: false,
      payment_other:[],
      payment_other_list:[],
      page: 1,
      page_all: null,
      start_page: null,
      end_page: null,
      check_page: 0,
      test: {},
    };
  },
  methods: {
    link(link) {
      window.location.href = link;
    },
    formatPrice(number) {
      return formatPrice(number);
    },
    open_model_close() {
      if (this.$refs.summary.validate()) {
        this.show_close = true;
      }
    },
    close_model_all() {
      this.show_close = false;
    },
    async closeStore() {
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      let id = this.$route.params.id;
      await HTTP_ARIN.get(`/pos/round/sum/${id}`, config).then((res) => {
        if (res.data.successful === true) {
          this.total.total_cash = res.data.sumResult.total_cash || 0;
          this.total.total_payment = res.data.sumResult.total_payment || 0;
          this.total.total_qr = res.data.sumResult.total_qr ? res.data.sumResult.total_qr : 0;
          this.total.total_qr_vat = res.data.sumResult.total_qr_vat || 0;
          this.total.total_credit = res.data.sumResult.total_credit || 0;
          this.total.total_etc = res.data.sumResult.total_etc || 0;
          this.total.total_amount = res.data.sumResult.total_amount || 0;
          this.total.total_vat = res.data.sumResult.total_vat || 0;
          this.total.total_no_vat = res.data.sumResult.total_no_vat || 0;
          this.total.total_cash_vat = res.data.sumResult.total_cash_vat || 0;
          this.total.total_payment_vat = res.data.sumResult.total_payment_vat || 0;
          this.total.total_credit_vat = res.data.sumResult.total_credit_vat || 0;
          this.total.total_etc_vat = res.data.sumResult.total_etc_vat || 0;
        }
      });
    },
    calculate() {
      this.total.total_all = 0;
      this.total.total_all =
        parseFloat( this.total_all.cash == "" || this.total_all.cash == null ? 0 : this.total_all.cash ) +
        parseFloat( this.total_all.cash_vat == "" || this.total_all.cash_vat == null ? 0 : this.total_all.cash_vat ) +
        parseFloat( this.total_all.payment == "" || this.total_all.payment == null ? 0 : this.total_all.payment ) +
        parseFloat( this.total_all.payment_vat == "" || this.total_all.payment_vat == null ? 0 : this.total_all.payment_vat ) +
        parseFloat( this.total_all.credit == "" || this.total_all.credit == null ? 0 : this.total_all.credit ) +
        parseFloat( this.total_all.credit_vat == "" || this.total_all.credit_vat == null ? 0 : this.total_all.credit_vat ) +
        parseFloat( this.total_all.etc == "" || this.total_all.etc == null ? 0 : this.total_all.etc ) +
        parseFloat( this.total_all.etc_vat == "" || this.total_all.etc_vat == null ? 0 : this.total_all.etc_vat ) +
        parseFloat( this.total_all.qr == "" || this.total_all.qr == null ? 0 : this.total_all.qr ) +
        parseFloat( this.total_all.qr_vat == "" || this.total_all.qr_vat == null ? 0 : this.total_all.qr_vat ) -
        parseFloat( this.total.total_amount == "" || this.total.total_amount == null ? 0 : this.total.total_amount );
    },
    async getStatusRoandSell() {
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      await HTTP_ARIN.get("/pos/checkroundinvoice", config).then((res) => {
        if (res.data.successful === true) {
          this.customer_id = res.data.user_edit_id;
          this.closeStore();
        }
      });
    },
    async saveData() {
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      let data = {
        total_amount: parseFloat(this.total.total_amount),
        total_cash: parseFloat(this.total.total_cash == 0 ? this.total.total_cash_vat : this.total.total_cash),
        total_payment: parseFloat(this.total.total_payment == 0 ? this.total.total_payment_vat : this.total.total_payment),
        total_credit: parseFloat(this.total.total_credit == 0 ? this.total.total_credit_vat : this.total.total_credit),
        total_etc: parseFloat(this.total.total_etc == 0 ? this.total.total_etc_vat : this.total.total_etc),
        total_qr: parseFloat(this.total.total_qr == 0 ? this.total.total_qr_vat : this.total.total_qr),
        total_qr_vat: parseFloat(this.total.total_qr_vat),
        diff_total_amount: parseFloat(this.total.total_all),
        diff_total_cash:
          parseFloat(this.total_all.cash) - parseFloat(this.total.total_cash),
        diff_total_payment:
          parseFloat(this.total_all.payment) -
          parseFloat(this.total.total_payment),
        diff_total_credit:
          parseFloat(this.total_all.credit) -
          parseFloat(this.total.total_credit),
        diff_total_etc:
          parseFloat(this.total_all.etc) - parseFloat(this.total.total_etc),
        diff_total_qr:
          parseFloat(this.total_all.qr) - parseFloat(this.total.total_qr),
        round_status: 0,
        note_total_amount: this.note,
      };
      let id = this.$route.params.id;
      
      await HTTP_ARIN.post(`/pos/round/save/${id}`, data, config).then(
        (res) => {
          if (res.data.successful === true) {
            this.open_model_close();
            this.$store.commit("clearSocket");
            this.$router.push(`/arin/pos/possalereportround/${id}`);
          }
        }
      );
    },
    getSum() {
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      let id = this.$route.params.id;
      HTTP_ARIN.get(`/pos/round/sum/${id}`, config).then((res) => {
        if (res.data.successful === true) {
          // this.sum_total_vat = res.data.sumResult.total_vat
          // this.sum_total_no_vat = res.data.sumResult.total_no_vat
        }
      });
    },
    async getPaymentOther(is_vat){
      this.open_payment_other = true      
      const body ={
        id:this.$route.params.id,
        is_vat:is_vat
      }
      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.store_arin.access_token}`,
        },
      };
      HTTP_ARIN.post(`/pos/paymentother`,body, config).then((res) => {
        if (res.data.successful === true) {
          this.payment_other = res.data.payment_other_list
          this.pagination(0, 10);
        }
      });
    },
    async pagination(start = null, end = null, search = "") {
      this.end_page = end;
      this.check_page = this.page;
      this.start_page = start;

      let productList_data = this.payment_other.filter((item) => item.invoice_code.includes(search));

      this.payment_other_list = productList_data.filter(
        (item, index) =>
          index >= parseFloat(this.start_page) &&
          index < parseFloat(this.end_page)
      );
      this.page_all = Math.ceil(
        parseFloat(productList_data.length) / parseFloat(10)
      );
      
    },
  },
  mounted() {
    this.getSum();
    this.getStatusRoandSell();
  },
};
</script>

<style scoped>
.btn_add_data {
  font-size: 16px;
  color: #fff;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%),
    #88b358 !important;
  border-radius: 10px;
  /* width: 200px; */
}

.border-close {
  border: 1px solid #d6bfaf;
}

.title_page_end {
  display: flex;
  align-items: flex-end;
}

.title_page_center {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.text-brown {
  color: #b0886b !important;
}

.text-green {
  color: #88b358 !important;
}

.text-red {
  color: #f28080 !important;
}

.btn-detail{
  min-width: 0!important;
  padding: 4px!important;
}
</style>
